// Global Components
// [Reference] https://dev.to/aligoren/registering-components-globally-p8m

// Third Party
import Vue from 'vue'
import VueInputAutowidth from 'vue-input-autowidth'
import Inview from 'vueinview'
import VueTyperPlugin from 'vue-typer'
import VueTypedJs from 'vue-typed-js'
import VueCarousel from 'vue-carousel'
import VueCollapse from 'vue2-collapse'
import TextareaAutosize from 'vue-textarea-autosize'
import VueChimera from 'vue-chimera'
import lineClamp from 'vue-line-clamp'
import infiniteScroll from 'vue-infinite-scroll'
import Vue2Filters from 'vue2-filters'
import VueEvents from 'vue-events'

// Fundanow
import fundaNowClient from '@/client/fundaNowClient'

// lodash (https://lodash.com/docs)
Object.defineProperty(Vue.prototype, '_', { value: require('lodash') })

// Components

// vue-countup-v2 (https://github.com/xlsdg/vue-countup-v2)
Vue.component('ICountUp',
  () => import('vue-countup-v2')
)

// vue-slick (https://github.com/staskjs/vue-slick)
Vue.component('Slick',
  () => import('vue-slick')
)

// vue-carousel (https://github.com/SSENSE/vue-carousel)
Vue.use(VueCarousel)

// vue-upload-component (https://lian-yue.github.io/vue-upload-component/#/en/documents)
Vue.component('file-upload',
  () => import('vue-upload-component')
)

// vue-ellipsis (https://justineo.github.io/vue-clamp/demo/)
Vue.component('VClamp',
  () => import('vue-clamp')
)

// vue-input-autowidth (https://github.com/syropian/vue-input-autowidth#readme)
Vue.use(VueInputAutowidth)

// vue-inview (https://github.com/rachmanzz/vue-inview)
Vue.use(Inview)

// vue-typer (https://github.com/cngu/vue-typer#readme)
Vue.use(VueTyperPlugin)

// vue-typed-js (https://github.com/Orlandster/vue-typed-js)
Vue.use(VueTypedJs)

// vue-typed-js (https://roszpun.github.io/vue-collapse)
Vue.use(VueCollapse)

// vue-textarea-autosize (https://github.com/devstark-com/vue-textarea-autosize)
Vue.use(TextareaAutosize)

// vue-infinite-scroll (https://github.com/ElemeFE/vue-infinite-scroll)
Vue.use(infiniteScroll)

// vue-chimera (https://vue-chimera.netlify.app/)
Vue.use(VueChimera, {
  axios: fundaNowClient,
  auto: false
})

// vue-line-clamp (https://github.com/Frondor/vue-line-clamp)
Vue.use(lineClamp, {
  // plugin options
})

// vue2-filters (https://github.com/freearhey/vue2-filters)
Vue.use(Vue2Filters)

// vue-events (https://github.com/cklmercer/vue-events)
Vue.use(VueEvents)
